import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import qs, { ParsedQs } from 'qs';
import _ from 'lodash';
import { Paper, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';

export default function SearchBar() {
  const [nativeQueryParams, setNativeQueryParams] = useSearchParams();
  const queryObject = qs.parse(nativeQueryParams.toString());

  const [searchTerm, setSearchTerm] = useState(queryObject.search || '');
  const setQuery = useMemo(
    () =>
      _.debounce(
        (search: string) => {
          const newQueryObject: ParsedQs = {
            ...queryObject,
            search,
          };
          if (search === '') delete newQueryObject.search;

          setNativeQueryParams(new URLSearchParams(qs.stringify(newQueryObject)));
        },
        1000,
        { trailing: true }
      ),
    []
  );

  const handleSearchUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    setQuery(newSearchTerm);
  };

  return (
    <TextField
      component={Paper}
      value={searchTerm}
      onChange={handleSearchUpdate}
      placeholder="Filter Search"
      sx={{ p: 2 }}
      slotProps={{
        input: {
          startAdornment: (
            <Search />
          ),
        }

      }}
    />
  );
}
